import { IChurn } from '../data/entities/customer/churn';
import { IConfiguredHttp } from './http';

export interface IChurnApi {
	getCustomerChurn: (id: string) => Promise<IChurn>;
	updateCustomerChurn: (id: string, customerChurn: IChurn) => Promise<IChurn>;
}

const churnApiFactory = (http: IConfiguredHttp, prefix = ''): IChurnApi => ({
	getCustomerChurn(id) {
		return http.get(`${prefix}/${id}/churn`);
	},
	updateCustomerChurn(id, customerChurn) {
		return http.put(
			`${prefix}/${id}/churn`,
			customerChurn
		);
	},
});

export default churnApiFactory;
